import type { API } from 'chessboard/api/config/types';

/**
 * Create the getContext method.
 */
export function createGetContext(context: API.Context) {
  /**
   * Get the context object.
   */
  return function getContext(): API.Context {
    return context;
  };
}
